import _ from 'lodash';

export default function createVerifiedBMPList({groupsList, loggedBMPs, flexdata}){
	let {verifiedBMPList} = flexdata;
	let bmpGroups = Array.isArray(groupsList) ? groupsList : [];
	let loggedBMPList = Array.isArray(loggedBMPs) ? loggedBMPs : [];

	if (!verifiedBMPList) verifiedBMPList = [];

	console.log("createVerifiedBMPsList params: groupsList:", bmpGroups, "loggedBMPs:", loggedBMPList, "verifiedBMPList:", verifiedBMPList);

	if (!bmpGroups.length){
		return _.cloneDeep(verifiedBMPList);
	}

	let toReturn = [];

	if (verifiedBMPList && verifiedBMPList.length){
		console.log("createVerifiedBMPsList loading existing verified BMPs with verifiedBMPList", verifiedBMPList)
		return loadExistingVerifiedBMPs(bmpGroups, loggedBMPList, verifiedBMPList);
	} else {
		console.log("creating new verified BMPs list")
		return createVerifiedBMPsList(bmpGroups, loggedBMPList);
	}

}

function loadExistingVerifiedBMPs(groupsList, loggedBMPs, passedVerifiedBMPList){

	let currentVerifiedBMPsList = createVerifiedBMPsList(groupsList, loggedBMPs);
	let toReturn = [];
	let passedVerifiedBMPListIds = _.map(passedVerifiedBMPList, "idpractice")

	for (var i = 0; i < currentVerifiedBMPsList.length; i++){
		let entry = currentVerifiedBMPsList[i];
		let passedIndex = passedVerifiedBMPListIds.indexOf(entry.idpractice)

		if (passedIndex == -1){
			entry.status = "";
		} else {
			entry.status = passedVerifiedBMPList[passedIndex].status;
		}

		toReturn.push(_.cloneDeep(entry));
	}

	return toReturn;
}

function createVerifiedBMPsList(passedBMPGroups, passedLoggedBMPs){
	let bmpGroups = Array.isArray(passedBMPGroups) ? _.cloneDeep(passedBMPGroups) : [];
	let loggedBMPs = Array.isArray(passedLoggedBMPs) ? passedLoggedBMPs : [];

	let loggedPractices = _.map(loggedBMPs, "idpractice");
	let toReturn = [];
	let status = "";

	for (var i = 0; i < bmpGroups.length; i++){
		let groupEntries = Array.isArray(bmpGroups[i].entries) ? bmpGroups[i].entries : [];
		for (var j = 0; j < groupEntries.length; j++){
			let {name, type, idpractice} = groupEntries[j];


			if (loggedPractices.indexOf(idpractice) == -1){
				toReturn.push({name, type, idpractice, status});
			}

		}
	}

	return toReturn;
}